import api from './axiosInstance';
import { BASE_URL } from './config'; // ✅ dùng dấu ngoặc nhọn

export const fetchPartners = () => api.get(`${BASE_URL}/partners/get-all`);

export const fetchMethods = (partnerId) =>
    api.get(`${BASE_URL}/partner-method/get-by-partner`, {
        params: { partnerId },
    });

export const createPartner = (data) =>
    api.post(`${BASE_URL}/partners`, data);

export const updatePartner = (data) =>
    api.put(`${BASE_URL}/partners`, data);

export const deletePartner = (id) =>
    api.delete(`${BASE_URL}/partners/${id}`);

export const submitFlow = (flowData) =>
    api.post(`${BASE_URL}/node-handler/process-flow/validate`, flowData);

export const fetchSchemaById = (schemaId) =>
    api.get(`${BASE_URL}/schema-config/${schemaId}`);

export const saveMappingToBackend = async ({ schemaId, fieldMapping }) =>
    api.put(`${BASE_URL}/schema-config/field-mapping/${schemaId}`, {
        fieldMapping,
    });

export const fetchFlowByMethodId = (partnerId, methodId) =>
    api.get(`${BASE_URL}/node-handler/flow`, {
        params: { partnerId, methodId },
    });
